<template>
  <div class="sd-page">
    <header class="sd-page-head">
      <div>
        <p class="sd-eyebrow">{{ eyebrow }}</p>
        <h1 class="sd-title">{{ title }}</h1>
        <p v-if="subtitle" class="sd-subtitle">{{ subtitle }}</p>
      </div>

      <label v-if="noticias.length" class="sd-search">
        <span class="material-symbols-outlined">search</span>
        <input v-model.trim="search" type="search" placeholder="Buscar noticia…" aria-label="Buscar noticia" />
        <button v-if="search" type="button" aria-label="Limpiar búsqueda" @click="search = ''">
          <span class="material-symbols-outlined">close</span>
        </button>
      </label>
    </header>

    <div v-if="loading" class="sd-grid">
      <div v-for="n in 6" :key="n" class="sd-skeleton ln-skeleton"></div>
    </div>

    <p v-else-if="error" class="sd-empty">
      <span class="material-symbols-outlined">cloud_off</span>
      No se pudieron cargar las noticias.
      <button type="button" class="sd-btn sd-btn--ghost" @click="cargar">Reintentar</button>
    </p>

    <p v-else-if="!filtradas.length" class="sd-empty">
      <span class="material-symbols-outlined">article</span>
      {{ search ? `No hay noticias que coincidan con «${search}».` : "Todavía no hay noticias publicadas." }}
    </p>

    <template v-else>
      <p v-if="search" class="ln-count">
        {{ filtradas.length }} resultado{{ filtradas.length === 1 ? "" : "s" }}
      </p>

      <div class="sd-grid">
        <card-noticia
          v-for="item in visibles"
          :key="item.id"
          :imageSrc="item.imagenPortada"
          :newTitle="item.titulo"
          :resumenNoticia="item.resumenNoticia"
          :fechaPublicacion="item.fechaPublicacion"
          :idnoticia="caritas ? 'caritas-' + item.id : item.id"
          :caritas="caritas"
          @getIdNews="abrir"
        />
      </div>

      <div v-if="visibles.length < filtradas.length" class="sd-more">
        <button type="button" class="sd-btn sd-btn--ghost" @click="limite += PAGINA">
          <span class="material-symbols-outlined">expand_more</span>
          Cargar más noticias
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import cardNoticia from "@/views/website/paginaPrincipal/UltimasNoticias.vue";
import { trackBusqueda } from "@/directives/analitica.js";

const PAGINA = 12;

function normalizar(texto) {
  return (texto || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

export default {
  name: "ListadoNoticias",
  components: { cardNoticia },
  props: {
    endpoint: { type: String, required: true },
    title: { type: String, default: "Noticias" },
    eyebrow: { type: String, default: "Actualidad" },
    subtitle: String,
    caritas: Boolean,
  },
  data() {
    return {
      PAGINA,
      noticias: [],
      loading: true,
      error: false,
      search: "",
      limite: PAGINA,
    };
  },
  computed: {
    filtradas() {
      const q = normalizar(this.search);
      if (!q) return this.noticias;
      return this.noticias.filter((n) => normalizar(`${n.titulo} ${n.resumenNoticia}`).includes(q));
    },
    visibles() {
      return this.filtradas.slice(0, this.limite);
    },
  },
  watch: {
    search(texto) {
      this.limite = PAGINA;
      trackBusqueda(this.caritas ? "noticias_caritas" : "noticias", texto);
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      this.error = false;
      try {
        const { data } = await axios.get(this.endpoint);
        this.noticias = (data.todasNoticias || []).sort((a, b) =>
          a.fechaPublicacion > b.fechaPublicacion ? -1 : a.fechaPublicacion < b.fechaPublicacion ? 1 : 0
        );
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    abrir(value) {
      this.$router.push({ name: "noticia", query: { id: value.id } });
    },
  },
};
</script>

<style scoped>
.ln-skeleton {
  height: 400px;
}

.ln-count {
  margin: -12px 0 20px;
  font-size: 0.9rem;
  color: var(--sd-muted);
}
</style>
